import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import CampaignActivityForm from "routes/constant_contact/components/CampaignActivityForm";

const CampaignActivityModal = ({ activity, open, onOpenChange, onSuccess }) => {
  const [internalOpen, setInternalOpen] = useState(false);
  const isControlled = open !== undefined;
  const actualOpen = isControlled ? open : internalOpen;
  const setOpen = isControlled ? onOpenChange : setInternalOpen;

  const handleSuccess = () => {
    setOpen(false);
    onSuccess?.();
  };

  const header = `${activity ? "Edit" : "New"} Campaign Activity`;

  return (
    <Dialog open={actualOpen} onOpenChange={setOpen}>
      {!isControlled && (
        <DialogTrigger
          render={<Button size="sm">New Campaign Activity</Button>}
        />
      )}
      <DialogContent>
        <DialogTitle>{header}</DialogTitle>
        <CampaignActivityForm
          activityId={activity?.id}
          onSuccess={handleSuccess}
          onCancel={() => setOpen(false)}
        />
      </DialogContent>
    </Dialog>
  );
};

export default CampaignActivityModal;
